import { Toast } from "@src/types/shared";

class ToastEventEmitter extends EventTarget {
    addToast(message: string, type: Toast["type"] = "success", delay = 5000) {
        const toast: Toast = {
            id: Math.random().toString(36).substr(2, 9),
            message,
            type,
            delay,
        };

        this.dispatchEvent(new CustomEvent("toast:add", { detail: toast }));
    }

    removeToast(id: string) {
        this.dispatchEvent(new CustomEvent("toast:remove", { detail: { id } }));
    }
}

// Global instance
export const toastEvents = new ToastEventEmitter();

// Convenience functions for easy usage
export const showToast = (
    message: string,
    type?: Toast["type"],
    delay?: number,
) => {
    toastEvents.addToast(message, type, delay);
};

export const emitSuccess = (message: string, delay?: number) =>
    showToast(message, "success", delay);
export const emitError = (message: string, delay?: number) =>
    showToast(message, "error", delay);
export const emitWarning = (message: string, delay?: number) =>
    showToast(message, "warning", delay);
export const emitInfo = (message: string, delay?: number) =>
    showToast(message, "info", delay);
